'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import classnames from "classnames";

import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";

import {capitalize} from "@uw-it-sis/lib-react/lib/Utils";

import optionalChargesStore from "./OptionalChargesStore";
import {Campus} from '@uw-it-sis/lib-react/lib/AppConstants';


class OpChargeASUW extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = optionalChargesStore;
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        this.store.updateFormData(name, value);
    }

    submitForm = (e) => {
        e.preventDefault();
        this.props.onSuccess();
    }

    render() {
        const campus = this.props.campus;
        const data = this.store.data;
        const formData = this.store.formData;

        if (
            data.asuw_update_sw !== "Y"
            ||
            (
                parseInt(data.exemption_code) >= 5
                &&
                parseInt(data.exemption_code) <= 9
            )
        ) {
            //...Don't display ASUW info if not updatable, or for tuition exemption students
            return null;
        }

        let link, abbr
        switch (campus) {
            case Campus.tacoma:
                abbr = "ASUWT";
                link = <><a href='https://www.tacoma.washington.edu/asuwt/' target='_blank'>Associated Students of the University of Washington Tacoma</a> (ASUWT)</>;
                break;
            case Campus.bothell:
                abbr = "ASUWB";
                link = <><a href='https://www.uwb.edu/asuwb' target='_blank'>Associated Students of the UW Bothell</a> (ASUWB)</>;
                break;
            default:
                abbr = "ASUW";
                link = <a href='https://hub.washington.edu/servicepage.php?q=asuw' target='_blank'>Associated Students of the University of Washington</a>
        }

        let disableButton = formData.ASUW !== "Y" && formData.ASUW !== "N";

        return (
            <>
                <h4 className="h2">Associated Students of the University of Washington {capitalize(campus)} {abbr}</h4>
                <Form onSubmit={this.submitForm}>
                    <fieldset>
                        <legend className="fs-6">
                            <p>Do you want to be a member of the {link}?</p>
                            <p>Selecting yes will allow you to vote in {abbr} elections. Membership is free and will not affect your tuition bill.</p>
                        </legend>
                        <Form.Check
                            label="Yes"
                            name="ASUW"
                            type="radio"
                            value="Y"
                            defaultChecked={formData.ASUW === "Y"}
                            onChange={this.handleChange}
                            id={`asuw-membership-yes`}
                        />
                        <Form.Check
                            label="No"
                            name="ASUW"
                            type="radio"
                            value="N"
                            defaultChecked={formData.ASUW === "N"}
                            onChange={this.handleChange}
                            id={`asuw-membership-no`}
                        />
                    </fieldset>
                    <Button aria-disabled={disableButton} type="submit" className={classnames({"disabled": disableButton})}>Continue</Button>
                </Form>
            </>
        );
    }
}

OpChargeASUW.propTypes = {
    campus: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default observer(OpChargeASUW);